import React, { useEffect, useState } from "react";
import { Label, Confirm } from "semantic-ui-react";
import { AcademicPeriod } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { AcademicPeriodForm } from "../AcademicPeriodForm";
import { CustomTable, BasicModal } from "../../../Shared";

import "./ListAcademicPeriod.scss";

const academicPeriodController = new AcademicPeriod();

export function ListAcademicPeriod(props) {
  const { academicCycleId, reload, onReload } = props;
  const [periods, setPeriods] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [confirmMessage, setConfirmMessage] = useState("");
  const { accessToken } = useAuth();

  useEffect(() => {
    if (!academicCycleId) {
      setPeriods([]);
      setLoading(false);
      return;
    }

    (async () => {
      setLoading(true);
      try {
        const response = await academicPeriodController.getPeriodsByCycle(
          accessToken,
          academicCycleId,
        );
        setPeriods(response);
      } catch (error) {
        console.error(error);
        setPeriods([]);
      }
      setLoading(false);
    })();
  }, [academicCycleId, reload, accessToken]);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openEditPeriod = (period) => {
    setSelectedPeriod(period);
    onOpenCloseModal();
  };

  const openCloseConfirm = (period) => {
    setSelectedPeriod(period);
    setConfirmMessage(
      `¿Estás seguro de ${period.status === 1 ? "cerrar" : "reabrir"} el período "${period.name}"?`,
    );
    setConfirmAction(period.status === 1 ? "close" : "reopen");
    onOpenCloseConfirm();
  };

  const onConfirmAction = async () => {
    try {
      if (confirmAction === "close") {
        await academicPeriodController.closePeriod(
          accessToken,
          selectedPeriod.id,
        );
      } else {
        await academicPeriodController.reopenPeriod(
          accessToken,
          selectedPeriod.id,
        );
      }
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const tableConfig = {
    headers: [
      "Período",
      "Nombre",
      "Fecha Inicio",
      "Fecha Fin",
      "Estado",
      "Acciones",
    ],
    fields: [
      {
        field: "periodNumber",
        component: "custom",
        align: "center",
        render: (row) => (
          <Label circular color="blue">
            {row.periodNumber}
          </Label>
        ),
      },
      {
        field: "name",
        dataType: "text",
        align: "left",
      },
      {
        field: "startDate",
        dataType: "date",
        format: "DD/MM/YYYY",
        align: "center",
      },
      {
        field: "endDate",
        dataType: "date",
        format: "DD/MM/YYYY",
        align: "center",
      },
      {
        field: "status",
        component: "Label",
        align: "center",
        getColor: (value) =>
          value === 1 ? "green" : value === 2 ? "red" : "grey",
        getText: (value) =>
          value === 1 ? "Activo" : value === 2 ? "Cerrado" : "Desconocido",
      },
      {
        buttons: [
          {
            color: "blue",
            icon: "pencil",
            placeholder: "Editar período",
            onClick: openEditPeriod,
          },
          {
            color: (row) => (row.status === 1 ? "orange" : "green"),
            icon: (row) => (row.status === 1 ? "lock" : "unlock"),
            placeholder: "Cerrar / reabrir período",
            onClick: openCloseConfirm,
          },
        ],
      },
    ],
    columnWidths: ["10%", "25%", "15%", "15%", "15%", "20%"],
  };

  return (
    <>
      <CustomTable tableConfig={tableConfig} data={periods} loading={loading} />
      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title={`Editar período: ${selectedPeriod?.name ?? ""}`}
      >
        <AcademicPeriodForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          period={selectedPeriod}
        />
      </BasicModal>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onConfirmAction}
        content={confirmMessage}
        size="mini"
      />
    </>
  );
}
